<div class="login-body">
  <div class="login-image" [ngStyle]="background" (click)="calculateBackground()"></div>
  <div class="card login-panel ui-fluid">
    <div class="login-panel-content">
      <form #f="ngForm">
        <div class="login-spiner" [style.z-index]="show_spin" aria-hidden="true">
          <div class="nb-spinner" role="status">
            <span class="sr-only">...</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <img src="assets/img/icon-login.svg" />
          </div>
          <div class="col-9 text-right">
            <h2 class="welcome-text">{{ 'LoginView.changePassword' | translate }}</h2>
            <span class="guest-sign-in">{{ 'LoginView.user' | translate }}: {{ user }}</span>
          </div>
          <div class="col-12 p-2">
            <label class="login-label">{{ 'LoginView.newPassword' | translate }}</label>
            <input pInput id="passNew" name="passNew" [(ngModel)]="passNew" autocomplete="off" type="password"
              [ngModelOptions]="{ standalone: true }" tabindex="1" class="w-100"
              (ngModelChange)="getPasswordStrength()" />
          </div>
          <div class="col-12 p-2">
            <label class="login-label">{{ 'LoginView.passwordConfirm' | translate }} </label>
            <input pInput id="passConfirm" name="passConfirm" [(ngModel)]="passConfirm" autocomplete="off"
              type="password" [ngModelOptions]="{ standalone: true }" tabindex="2" class="w-100"
              (ngModelChange)="getPasswordStrength()" />
          </div>
          <div class="col-12 p-2 text-center">
            <button pButton appDebounceClick tabindex="4" (debounceClick)="onSubmit()"
              class="btn btn-primary btn-lg btn-block" id="btn" [disabled]="!isValidPassword()">
              {{ 'LoginView.doChangePassord' | translate }} </button>
            <a tabindex="3" href="#login">{{ 'LoginView.returnToLogin' | translate }}</a>
          </div>
          <div class="col-12 p-2 text-center" *ngIf="!isValidPassword() && errorMsg">
            <span class="text-danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}</span>
          </div>
          <!-- <div class="col-12 ui-md-6 link-pane">
            <a href="#">Forget Password?</a>
          </div> -->
        </div>
      </form>
    </div>
  </div>
</div>